var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfigSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.999,
    height: 12,
    viewBox: "0 0 12.999 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1712",
    "data-name": "Group 1712",
    transform: "translate(-46.029 -352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_box_FILL0_wght400_GRAD0_opsz48",
    d: "M7.069,18.83A1.1,1.1,0,0,1,6,17.761V7.069A1.1,1.1,0,0,1,7.069,6H17.761A1.1,1.1,0,0,1,18.83,7.069V17.761a1.1,1.1,0,0,1-1.069,1.069Zm0-1.069H17.761V7.069H7.069V17.761Zm0,0h0V7.069h0V17.761Z",
    transform: "translate(40.029 346)",
    fill: "#35697e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    y2: 7,
    transform: "translate(52.5 354.915)",
    fill: "none",
    stroke: "#e11e24",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    y2: 7,
    transform: "translate(56 358.415) rotate(90)",
    fill: "none",
    stroke: "#e11e24",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigSelected);
export default __webpack_public_path__ + "static/media/config-selected.fd28442c97b111bdfcb04c7aec4302d2.svg";
export { ForwardRef as ReactComponent };